export default __webpack_public_path__ + "static/ogimage-5f9e7474c83ba81ab628e3a2405f2855.png";